import { IssuesWrapper } from "@vp/gatsby-pages-issues-tracker-plugin";
import { Box, FlexBox, Typography } from "@vp/swan";
import TokenEngine from "@vp/vp-js-token-engine";
import React, { useContext, useEffect, useState } from "react";
import PageConfig from "../../utils/PageConfig";
import { getProductPageUrl } from "../../services/UrlService";
import { Icons } from "../../utils/Icons";
import { mapToMailingServicesMpv } from "../../utils/mailingServicesUtil";
import { Translations } from "../../utils/Translation";
import { CloudinaryIcon } from "../CloudinaryIcon";
import { PurifiedComponent } from "../PurifiedComponent";
import { PageStaticDataContext } from "../../contexts/PageStaticDataContextProvider";

interface MailingServiceDescriptionCalloutProps {}

export const MailingServiceDescriptionCallout = (props: MailingServiceDescriptionCalloutProps) => {
  const { locale, mpv } = useContext(PageStaticDataContext);
  const { mpvId } = mpv;
  const mailingServiceMpvId = mapToMailingServicesMpv(mpvId, locale);
  const [mailingServicesProductPageUrl, setMailingServicesProductPageUrl] = useState<string>("");

  if (!mailingServiceMpvId) {
    return <></>;
  }

  useEffect(() => {
    let isComponentMounted = true;

    const getMailingServicesProductPageUrl = async () => {
      const url = await getProductPageUrl(mailingServiceMpvId, locale, PageConfig.tenant);

      if (url && isComponentMounted) {
        setMailingServicesProductPageUrl(url);
      }
    };
    getMailingServicesProductPageUrl();

    return () => {
      isComponentMounted = false;
    };
  }, [mailingServiceMpvId]);

  const mailingServicesIcon = Icons.getInstance().getIcon("mailingServicesIcon");
  const mailingServicesDescriptionEntry = Translations.getInstance().getTranslationEntry(
    "mailingServicesDescription"
  );
  const tokenEngine = new TokenEngine();
  const mailingServicesDescription = tokenEngine.replace(mailingServicesDescriptionEntry, {
    OpenAnchor: `<a href="${mailingServicesProductPageUrl}">`,
    CloseAnchor: "</a>",
  });

  return (
    <FlexBox alignItems="center" flexDirection="row" mb={"6"}>
      <Box>
        <CloudinaryIcon image={mailingServicesIcon} />
      </Box>
      <Box>
        <IssuesWrapper
          targetNodes={[mailingServicesDescriptionEntry]}
          elementName="Mailing Services Description"
        >
          <Typography fontSize={"small"}>
            <PurifiedComponent component="div" content={mailingServicesDescription} />
          </Typography>
        </IssuesWrapper>
      </Box>
    </FlexBox>
  );
};

export default MailingServiceDescriptionCallout;
